// Qualification: a role/credential an employee can hold (from the `qualifications`
// table). Order maps encode domain rankings.

import type { Enums, Tables } from '#modules/database'

export type Qualification = Pick<Tables<'qualifications'>,
  'id' |
  'name' |
  'abbreviation' |
  'category' |
  'cs_level' |
  'rx_level' |
  'provider_type' |
  'ics_position' |
  'sort_order'
>

// PostgREST select column list for a qualification.
//
// MUST be a string literal, not derived (e.g. `cols.join(',')`): supabase-js parses
// the select string as a template-literal TYPE at compile time to infer the query
// result shape. A widened `string` breaks that inference (ParserError). That is also
// why the column list is duplicated in the Pick above and the string below: TS can't
// cheaply bridge a type to a literal select string, so keep them in sync by hand.
// Add/remove a column here AND in the Pick together.
export const QUAL_FIELDS = 'id,name,abbreviation,category,cs_level,rx_level,provider_type,ics_position,sort_order'

export type QualCategory = Enums<'qual_category'>

export type QualCSLevel = Enums<'qual_cs_level'>
export const QualCSLevelOrder = {
  none:      0,
  witness:   1,
  dispenser: 2,
} as const satisfies Record<QualCSLevel, number>

export type QualRxLevel = Enums<'qual_rx_level'>
export const QualRxLevelOrder = {
  none:       0,
  dispenser:  1,
  prescriber: 2,
} as const satisfies Record<QualRxLevel, number>

export type QualProviderType = Enums<'qual_provider_type'>
export const QualProviderTypeOrder = {
  none:      0,
  emt:       1,
  pmd:       2,
  nurse:     3,
  app:       4,
  physician: 5,
} as const satisfies Record<QualProviderType, number>
